import { UserSettings } from '@data';
import { DEFAULT_USER_SETTINGS, useUserSettings } from '@queries';

export const DEFAULT_USER_SETTINGS_WITH_NULL: UserSettings = {
    ...DEFAULT_USER_SETTINGS,
    dateOfBirth: null,
    sex: null,
    handicap: 54,
    showCorridors: false,
    showComparison: false,
    showGoal: true,
    leftHanded: false,
    liveView: false,
    userId: '',
    comparisonSwingId: null,
};

export function useUserSettingsWithDefaults(userId?: string) {
    const { data: userSettings, ...rest } = useUserSettings(userId);
    return { data: userSettings ?? DEFAULT_USER_SETTINGS_WITH_NULL, ...rest };
}
